<template>
  <div class="faq wrapper-secondary">
    <div
      v-for="(item, index) in faqItems"
      :key="index"
      class="faq-item active"
      @click="selectTab(index)"
    >
      <p class="faq-question" :class="isActive(index)">
        {{ item.question }}
        <span class="faq-icon">
          <TriangleIcon :rotate="isActive(index) ? 'up' : 'down'" />
        </span>
      </p>
      <div class="faq-answer text_page" :class="isActive(index)">
        <ul>
          <li v-for="(answer, i) in item.answer" :key="i">
            <span v-html="answer.text"></span>
            <ol v-if="answer['list-num']">
              <li
                v-for="(text, j) in answer['list-num']"
                :key="j"
                v-html="text"
              ></li>
            </ol>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import TriangleIcon from "../common/icons/Triangle.vue";

const { locale, messages } = useI18n();

const activeTab = ref(null);

const faqItems = computed(() => {
  const currentLocale = locale.value;
  const localeMessages = messages.value?.[currentLocale];
  return localeMessages?.faq?.items || [];
});

const selectTab = (index) => {
  activeTab.value = activeTab.value === index ? null : index;
};

const isActive = (index) => {
  return activeTab.value === index ? "active" : "";
};
</script>

<style lang="scss" scoped>
@use "../../scss/variables" as *;
.faq {
  padding: 0;
  overflow: hidden;
}

.faq-item {
  position: relative;
}

.faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 40px;
  width: 100%;
  line-height: 1.3;
  font-weight: 500;
  letter-spacing: -0.025em;
  border-bottom: 1px solid;
  color: var(--back-color);
  border-color: rgba(0, 0, 0, 0);
  background-color: var(--body-color-second);
  font-size: 27px;
  transition: 0.3s all;
  z-index: 10;

  &.active {
    border-color: var(--font-color);
  }

  .faq-icon {
    fill: var(--back-color);
    margin-left: 15px;
    width: 16px;
  }
}

.faq-answer {
  position: relative;
  padding: 0 40px;
  font-weight: 400;
  line-height: 1.3156;
  letter-spacing: -0.017em;
  color: var(--back-color);
  transform-origin: top;
  transform: translateY(-100%) rotateX(90deg);
  opacity: 0;
  transition: all 0.5s ease;
  height: 0;

  &.active {
    display: block;
    transform: translateY(0) rotateX(0);
    padding-top: 40px;
    padding-bottom: 40px;
    opacity: 1;
    height: auto;
  }
}

@media screen and (max-width: $mobile) {
  .faq-question {
    font-size: 18px;
    padding: 20px;
  }

  .faq-answer {
    &.active {
      padding-top: 20px;
      padding-bottom: 20px;
    }
  }
}
</style>
